<template>
    <div>
        <div>
            <product-alerts :status="alert" v-model="alert"></product-alerts>
        </div>
        <transition name="vue-table-loader">
            <div class="vue-table-loader" v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
        </transition>
        <transition name="fade">
            <div v-if="shopifyCredentialsModal" class="modal-wrapper">
                <div class="modal-bg" @click="shopifyCredentialsModal = false"></div>
                <div class="modal-inner p-4">
                    <div class="row mx-4 pb-1">
                        <p class="font-weight-bold">
                            Shopify Credentials
                        </p>
                    </div>
                    <div class="row mx-4 my-0 pb-0 d-flex flex-column">
                        <div>
                            <label for="">
                                Confirm Shopify Credential
                            </label>
                        </div>
                        <div>
                            <input type="text" class="form-control">
                        </div>
                        <button class="btn btn-primary mt-3" @click="submitSetFolder">
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </transition>
        <clear-sync-queue-modal
            v-if="clearSyncModal"
            @close-clear-modal="closeClearModal"
            @keep-sync-queue="keepSyncQueue"
            @clear-sync-queue="clearSyncQueue"
        ></clear-sync-queue-modal>
        <edit-property-header-block action-label="Edit Channel" :property-label="channelInfo.channel_name"></edit-property-header-block>
        <div class="card panel panel-default">
        <div class="card-block">
            <section class="product-details">
                <form action="" method="post" enctype="multipart/form-data" id="channel-form">
                    <input name="_method" value="PUT" type="hidden">
                    <input name="_token" :value="csrfToken" type="hidden">
                    <div class="ks-tabs-container ks-tabs-default ks-tabs-no-separator">
                        <ul class="nav ks-nav-tabs">
                            <li class="nav-item"><a href="#" class="nav-link active" data-toggle="tab" data-target="#channel_details"  @click="setCurrentTab('details')">Details</a></li>
                            <li v-if="showProductTypes()" class="nav-item"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_product_types"  @click="setCurrentTab('product_types')">Product Types</a></li>
                            <li v-if="showAssets()" class="nav-item"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_assets" @click="setCurrentTab('assets')">Assets</a></li>
                            <li class="nav-item"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_delete"  @click="setCurrentTab('delete')">Delete</a></li>
                            <li v-if="showTools()" class="nav-item"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_tools"  @click="setCurrentTab('tools')">Tools</a></li>
                            <li v-if="showImport()" class="nav-item"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_import"  @click="setCurrentTab('import')">Import</a></li>
                            <li v-if="showStats()" class="nav-item"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_stats"  @click="setCurrentTab('stats')">Stats</a></li>
                            <li class="nav-item" v-if="hasSpecificFields"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_specific" @click="setCurrentTab('options')">{{ channelInfo.channel_name }} Options</a></li>
                            <li class="nav-item" v-if="canSeeAdminFields"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_admin" @click="setCurrentTab('admin')">Admin</a></li>
                            <li class="nav-item" v-if="canSeeAdminFields && channelType.name == 'FTP Import'"><a href="#" class="nav-link" data-toggle="tab" data-target="#channel_ftp" @click="setCurrentTab('ftp')">FTP Info</a></li>
                            <li class="nav-item" v-if="channelType.sync_type == 'generic_sync_v2'"><a href="#" class="nav-link" data-toggle="tab" data-target="#generic_sync_v2" @click="setCurrentTab('generic_sync_v2')">Sync Queue</a></li>
                        </ul>

                        <div class="tab-content">
                            <div id="channel_details" class="tab-pane active">
                                <div class="panel-body">
                                    <div v-if="channelType.name == 'eBay'">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h3 class="pt-2">Ebay Status</h3>
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col-md-6 mt-2">
                                                <div v-if="ebayStatusUp"><span class="greenDot"></span> Online: {{ebayResponse}}</div>
                                                <div v-else><span class="redDot" ></span> Offline: {{ebayResponse}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <channel-connect v-if="channelInfo.show_workflow" :channelId="channelInfo.id"></channel-connect>
                                    <div v-if="channelType.name == 'Shopify' || channelType.name == 'ShopifyGQL'">
                                        <div v-for="group in shopifyChannelItems" :key="group.groupingName">
                                            <div class="row">
                                                <div class="col-md-12 clearfix">
                                                    <h3>{{ group.groupingName }}</h3>
                                                    <p v-if="group.groupingDescription" v-html="group.groupingDescription" class="text-muted mt-2 mb-0" style="max-width: 60ch;"></p>
                                                </div>
                                            </div>
                                            <input-loader :fields="group.groupItems"></input-loader>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="group in channel.items" :key="group.groupingName">
                                            <div class="row">
                                                <div class="col-md-12 clearfix">
                                                    <h3>{{group.groupingName}}</h3>
                                                </div>
                                            </div>
                                            <input-loader :fields="filterHiddenFields(group.groupItems)"></input-loader>
                                        </div>
                                    </div>

                                    <div v-if="channelType.name == 'GoogleMerchant'">
                                        <input type="file" id="upload_google_json_file">
                                        <a class="btn btn-primary" id="upload_google_json_file_btn" @click="uploadGoogleJson()" href="javascript:void(0)">Upload Google Json File</a>
                                    </div>

                                    <div v-if="canSeeAdminFields && (channelType.name == 'AmazonPimUS' || channelType.name == 'AmazonPimCanada')">
                                        <input type="file" id="upload_spreadsheet_file">
                                        <a class="btn btn-primary" id="upload_spreadsheet_btn" @click="uploadAmazonSpreadsheet()" href="javascript:void(0)">Upload Amazon Spreadsheet</a>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-md-9 ml-auto text-right">
                                            <button v-on:click="beforeSaveChannel()" type="button" class="btn btn-primary">Save</button>
                                            <a :href="baseUrl+ '/channels'" class="btn btn-secondary">
                                                Cancel
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="channel_product_types" class="tab-pane" v-if="channelInfo.has_schemas">
                                <div class="panel-body">
                                    <schema-selector :channel-id="channelInfo.id"></schema-selector>
                                </div>
                            </div>
                            <div id="channel_assets" class="tab-pane">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h3 class="pt-2">Assets</h3>
                                        </div>
                                        <div class="col-md-6 text-right">
                                            <a class="btn btn-primary" data-toggle="collapse" data-target="#asset_upload" href="javascript:void(0)">Upload Asset</a>
                                            <a class="btn btn-primary" data-toggle="collapse" data-target="#create_asset" href="javascript:void(0)">Add Asset by URL</a>
                                        </div>
                                    </div>
                                    <div class="row mb-4" id="asset_forms">
                                        <div class="col md-12">
                                            <div id="create_asset" class="collapse border p-3" data-parent="#asset_forms">
                                                <div class="form-group row">
                                                    <div class="col-md-3 col-form-label text-right">New Asset URL</div>
                                                    <div class="col-md-9">
                                                        <input type="text" name="asset_url" class="form-control" v-model="assetUploadUrl">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12 text-right">
                                                        <a :disabled="assetUploadUrl === ''" @click="createAssetByUrl()" class="btn btn-primary">Save</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div id="asset_upload" class="collapse text-right border p-3" data-parent="#asset_forms">
                                                <vue-dropzone
                                                    id="assetDropzone"
                                                    acceptedFiles="image/*,application/pdf,.psd"
                                                    withCredentials="true"
                                                    ref="assetDropzone"
                                                    :useCustomSlot=true
                                                    :options="dropzoneOptions">
                                                    <div class="dropzone-custom-content">
                                                        <h3 class="dropzone-custome-title">Drop files here or click to upload</h3>
                                                    </div>
                                                </vue-dropzone>
                                                <a class="btn btn-primary" id="upload_continue_private" @click="uploadAssets()" href="javascript:void(0)">Upload</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="channel_delete" class="tab-pane">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h3 class="pt-2">Delete Channel</h3>
                                        </div>
                                        <div class="col-md-6 text-right">
                                            <a class="btn btn-primary" data-toggle="collapse" data-target="#delete_channel" href="javascript:void(0)">Delete Channel</a>
                                        </div>
                                    </div>
                                    <div class="row mb-4" id="channel_deletion_form">
                                        <div class="col md-12">
                                            <div id="delete_channel" class="collapse border p-3" data-parent="#channel_deletion_form">
                                                <div class="form-group row">
                                                    <div class="col-md-3 col-form-label text-right">Confirm Channel Deletion by typing DELETE</div>
                                                    <div class="col-md-9">
                                                        <input type="text" name="confirmChannelDeletion" class="form-control" v-model="confirmChannelDeletion">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12 text-right">
                                                        <a :disabled="confirmChannelDeletion === ''" @click="deleteChannel()" class="btn btn-primary">DELETE CHANNEL</a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="channel_tools" class="tab-pane">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h3 class="pt-2">Tools</h3>
                                        </div>
                                        <div class="col-md-12 d-flex sync-buttons">
                                            <a :class="toolButtonClass('product')" @click="toggleToolVisible('product')">Sync Products to Channel</a>
                                            <a :class="toolButtonClass('prices')" @click="toggleToolVisible('prices')" v-if="channelType.name != 'Wynshop'">Sync Prices to Channel</a>
                                            <a :class="toolButtonClass('inventory')" @click="toggleToolVisible('inventory')" v-if="channelType.name != 'Wynshop'">Sync Inventory to Channel</a>
                                            <a :class="toolButtonClass('options')" @click="toggleToolVisible('options')" v-if="channelType.name == 'BigCommerce'">Sync Product Options to Channel</a>
                                            <a :class="toolButtonClass('fullMode')" @click="toggleToolVisible('fullMode')">Sync Products to Channel, Full mode</a>
                                            <a :class="toolButtonClass('fullNoAssets')" @click="toggleToolVisible('fullNoAssets')">Sync products fully except assets to Channel</a>
                                            <a :class="toolButtonClass('categories')" @click="toggleToolVisible('categories')">Sync Categories to Channel</a>
                                            <a :class="toolButtonClass('locations')" @click="toggleToolVisible('locations')" v-if="channelType.name == 'Wynshop'">Sync Product Locations</a>
                                        </div>
                                        <div class="col-md-6 mt-2">
                                            <p class="text-danger">
                                                <strong>Warning!</strong> A sync will overwrite your products in the store with the data stored in the PIM.
                                                This could remove images and data that is in the store that is not currently in the PIM. Please make sure that your data is complete in the PIM before you continue.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_products_form" v-if="toolState.product">
                                        <div class="col md-12">
                                            <div id="sync_products" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-PRODUCTS</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncProducts" class="form-control" v-model="confirmSyncProducts">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncProducts === ''" @click="bulkSyncByType('products')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_prices_form" v-if="toolState.prices">
                                        <div class="col md-12">
                                            <div id="sync_prices" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-PRICES</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncPrices" class="form-control" v-model="confirmSyncPrices">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncPrices === ''" @click="bulkSyncByType('prices')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_inventory_form" v-if="toolState.inventory">
                                        <div class="col md-12">
                                            <div id="sync_inventory" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-INVENTORY</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncInventory" class="form-control" v-model="confirmSyncInventory">
                                                    </div>
                                                    <div class="col-md-12 col-form-label"><small><strong>WARNING:</strong> If channel inventory is enabled, this action will overwrite inventory levels in your channel with those in the PIM!</small></div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncInventory === ''" @click="bulkSyncByType('inventory')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_product_options_form" v-if="toolState.options">
                                        <div class="col md-12">
                                            <div id="sync_product_options" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-PRODUCT-OPTIONS</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncProductOption" class="form-control" v-model="confirmSyncProductOption">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncProductOption === ''" @click="bulkSyncByType('product_options')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_products_full_form" v-if="toolState.fullMode">
                                        <div class="col md-12">
                                            <div id="sync_products_full" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-PRODUCTS-FULL</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncProductsFull" class="form-control" v-model="confirmSyncProductsFull">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncProductsFull === ''" @click="bulkSyncByType('products_full')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_products_full_no_assets_form" v-if="toolState.fullNoAssets">
                                        <div class="col md-12">
                                            <div id="sync_products_full_no_assets" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-PRODUCTS-FULL-NO-ASSETS</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncProductsFullNoAssets" class="form-control" v-model="confirmSyncProductsFullNoAssets">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncProductsFullNoAssets === ''" @click="bulkSyncByType('products_full_no_assets')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_categories_form" v-if="toolState.categories">
                                        <div class="col md-12">
                                            <div id="sync_categories" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-CATEGORIES</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncCategories" class="form-control" v-model="confirmSyncCategories">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncCategories === ''" @click="bulkSyncByType('categories')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-12" id="sync_locations_form" v-if="toolState.locations">
                                        <div class="col md-12">
                                            <div id="sync_locations" class="border p-3">
                                                <div class="form-group row">
                                                    <div class="col-md-12 col-form-label">Confirm by typing SYNC-LOCATIONS</div>
                                                    <div class="col-md-3">
                                                        <input type="text" name="confirmSyncLocations" class="form-control" v-model="confirmSyncLocations">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-md-12">
                                                        <a :disabled="confirmSyncLocations === ''" @click="bulkSyncByType('locations')" class="btn btn-primary">Begin Sync</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="channel_import" class="tab-pane">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h3 class="pt-2">Import</h3>
                                        </div>
                                        <div class="col-md-12">
                                            <a class="btn btn-primary" id="run_import" @click="runImport()" href="javascript:void(0)" v-if="channelType.name !== 'Wynshop'">Import All Store</a>

                                            <a class="btn btn-primary" id="run_import_product_url" @click="runImportProductUrl()" href="javascript:void(0)" v-if="channelType.name !== 'Wynshop'">Import Product URLs</a>

                                            <a class="btn btn-primary" id="run_wynshop_categories_import" @click="runImportWynshopCategories()" href="javascript:void(0)" v-if="channelType.name == 'Wynshop'">1- Import Wynshop Categories</a>
                                            <a class="btn btn-primary" id="run_wynshop_stores_import" @click="runImportWynshopStores()" href="javascript:void(0)" v-if="channelType.name == 'Wynshop'">2- Import Wynshop Stores</a>
                                            <a class="btn btn-primary" id="run_wynshop_fulfillment_import" @click="runImportWynshopFulfillments()" href="javascript:void(0)" v-if="channelType.name == 'Wynshop'">3- Import Wynshop Fulfillment Centers</a>

                                            <a class="btn btn-primary" id="run_shopify_channels_import" @click="runImportShopifyChannels()" href="javascript:void(0)" v-if="channelType.name == 'Shopify' || channelType.name == 'ShopifyGQL'">Import Shopify Sales Channels</a>

                                            <a class="btn btn-primary" id="run_shopify_countries_import" @click="runImportShopifyPriceListCountries()" href="javascript:void(0)" v-if="channelType.name == 'Shopify' || channelType.name == 'ShopifyGQL'">Import Shopify Price List Countries</a>

                                            <a class="btn btn-primary" id="run_shopify_inventory_location_import" @click="runImportShopifyInventoryLocations()" href="javascript:void(0)" v-if="channelFieldOptions['useInventoryLocations'] && channelType.name == 'Shopify'">Import Inventory Locations</a>
                                            <a class="btn btn-primary" id="run_shopify_localization_import" @click="runImportShopifyLocalizations()" href="javascript:void(0)" v-if="channelFieldOptions['isShopifyLocalizationFeatureEnabled'] && channelType.name == 'ShopifyGQL'">Import Shopify Languages</a>

                                            <a class="btn btn-primary" id="run_magento_config_import" @click="runImportConfig()" href="javascript:void(0)" v-if="channelType.name == 'Magento2'">Import Configuration</a>

                                            <a class="btn btn-primary" id="run_bc_import_msfchannels" @click="runImportBigCommerceMSFChannels('channels')" href="javascript:void(0)" v-if="channelType.name == 'BigCommerce' && features.includes('bigcommerce_msfchannels')">Import BigCommerce Multi-Store Channels</a>

                                            <a class="btn btn-primary" id="run_bc_import_msfchannels" @click="runImportBigCommerceMSFChannels('products')" href="javascript:void(0)" v-if="channelType.name == 'BigCommerce' && features.includes('bigcommerce_msfchannels')">Import BigCommerce Multi-Store Product Channel Assignments</a>

                                            <a class="btn btn-primary" id="run_bc_import_msfchannels" @click="runImportBigCommerceMSFChannels('categories')" href="javascript:void(0)" v-if="channelType.name == 'BigCommerce' && features.includes('bigcommerce_msfchannels')">Import BigCommerce Multi-Store Categories</a>

                                            <a class="btn btn-primary" id="run_bc_import_msfchannels" @click="runImportBigCommerceMSFChannels('priceLists')" href="javascript:void(0)" v-if="channelType.name == 'BigCommerce' && features.includes('bigcommerce_msfchannels')">Import BigCommerce Multi-Store Price Lists</a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div id="channel_stats" class="tab-pane">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h3 class="pt-2">Stats</h3>
                                        </div>
                                        <div class="col-md-12">
                                            # of parent/single products mapped: {{stats.count_parent_products}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="channel_specific" v-if="hasSpecificFields" class="tab-pane">
                                <specific-bigcommerce v-if="channelType.name == 'BigCommerce'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-bigcommerce>
                                <specific-shopify v-if="channelType.name == 'Shopify'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-shopify>
                                <specific-shopify-gql v-if="channelType.name == 'ShopifyGQL'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-shopify-gql>
                                <specific-magento2 v-if="channelType.name == 'Magento2'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-magento2>
                                <specific-google-merchant v-if="channelType.name == 'GoogleMerchant'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-google-merchant>
                                <specific-nuorder v-if="channelType.name == 'Nuorder'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-nuorder>
                                <specific-wynshop v-if="channelType.name == 'Wynshop'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-wynshop>
                                <specific-pagination v-if="channelType.name == 'Pagination.com'" ref="channelSpecific" :channelvalues="channelInfo" :channeloptions="channelFieldOptions" @channel-specific-save="saveChannel"></specific-pagination>
                            </div>

                            <div id="channel_admin" v-if="canSeeAdminFields" class="tab-pane">
                                <specific-admin :channelvalues="channelInfo" ref="adminSpecific" @channel-specific-save="saveChannel"></specific-admin>
                            </div>
                            <div id="channel_ftp" v-if="canSeeAdminFields" class="tab-pane">
                                <ftp-info-index :channelvalues="channelInfo"
                                                ref="ftpSpecific"
                                                @channel-specific-save="saveChannel"></ftp-info-index>
                            </div>

                            <div id="generic_sync_v2" v-if="channelType.sync_type == 'generic_sync_v2'" class="tab-pane">
                                <generic-sync-v2
                                    :channelId="channelInfo.id"
                                ></generic-sync-v2>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host;
    import Vue from 'vue';
    import VueEvents from 'vue-events';

    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import axios from 'axios';
    import ProductAlerts from '../products/product-details-alerts.vue';
    import InputLoader from '../form/form-loader.vue';
    import ChannelConnect from './connect.vue';
    import SchemaSelector from './schema-selector.vue';
    import EditPropertyHeaderBlock from '../generic/edit-property-header-block.vue';
    import SpecificBigCommerce from './specific-bigcommerce.vue';
    import SpecificShopify from './specific-shopify.vue';
    import SpecificShopifyGQL from './specific-shopify-gql.vue';
    import SpecificMagento2 from './specific-magento2.vue';
    import SpecificGoogleMerchant from './specific-google-merchant.vue';
    import SpecificNuorder from './specific-nuorder.vue';
    import SpecificWynshop from './specific-wynshop.vue';
    import SpecificPaginationCom from './specific-pagination-com.vue';
    import SpecificAdmin from './specific-admin.vue';
    import GenericSyncV2 from './generic-sync-v2/generic-sync-v2.vue';
    import ClearSyncModal from './generic-sync-v2/clear-sync-queue-modal.vue';
    import FtpInfoIndex from "../ftp-info/ftp-info-index";

    import { cloneDeep } from "lodash"


    Vue.use(VueEvents);
    export default {
        name: 'create-channel',
        components: {
            'input-loader': InputLoader,
            'product-alerts': ProductAlerts,
            vueDropzone: vue2Dropzone,
            'channel-connect': ChannelConnect,
            'schema-selector': SchemaSelector,
            'edit-property-header-block': EditPropertyHeaderBlock,
            'specific-bigcommerce': SpecificBigCommerce,
            'specific-shopify': SpecificShopify,
            'specific-shopify-gql': SpecificShopifyGQL,
            'specific-magento2': SpecificMagento2,
            'specific-google-merchant': SpecificGoogleMerchant,
            'specific-nuorder': SpecificNuorder,
            'specific-wynshop': SpecificWynshop,
            'specific-pagination': SpecificPaginationCom,
            'specific-admin': SpecificAdmin,
            'generic-sync-v2': GenericSyncV2,
            'clear-sync-queue-modal': ClearSyncModal,
            'ftp-info-index': FtpInfoIndex
        },
        props: [],
        data() {
            return {
                baseUrl: base_url,
                datepickerOptions: {
                    format: 'MM-DD-YYYY',
                },
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 20000,
                },
                toolState: {
                    product: true,
                    prices: false,
                    inventory: false,
                    options: false,
                    fullMode: false,
                    fullNoAssets: false,
                    categories: false,
                    locations: false
                },
                uploadedFiles: [],
                uploadError: null,
                currentStates: null,
                uploadFieldName: 'assets',
                loading: false,
                vueDropezone: vue2Dropzone,
                assetDate : {
                    public_images : [],
                    public_non_images : [],
                },
                editAsset : {},
                assetUploadUrl: '',
                formData: {},
                dropzoneOptions: {
                    addRemoveLinks: true,
                    url: base_url + '/channels/upload-asset',
                    thumbnailWidth: 150,
                    headers: {'X-CSRF-Token': $('meta[name=csrf-token]').attr('content')},
                    maxFiles: 1,
                },
                uiStates: {
                    errorMessage: '',
                    showLoading: false
                },
                channel: dataObject.channelFormData,
                channelFieldOptions: dataObject.channelFieldOptions,
                channelInfo: dataObject.channel,
                channelType: dataObject.channelType,
                canSeeAdminFields: dataObject.canSeeAdminFields,
                postURL: base_url + "/channels/" + dataObject.channel.id,
                csrfToken: document.querySelector('meta[name="csrf-token"]').content,
                stats: {},
                confirmChannelDeletion: '',
                confirmSyncProducts: '',
                confirmSyncPrices: '',
                confirmSyncInventory: '',
                confirmSyncProductOption: '',
                confirmSyncProductsFull: '',
                confirmSyncCategories: '',
                confirmSyncLocations: '',
                currentTab: 'details',
                mountedWithSyncEnabled: '',
                clearSyncModal: false,
                shopifyCredentialsModal: false,
                ebayResponse: null,
                ebayStatusSuccessMessage: "eBay API is working as expected.",
                ebayStatusErrorMessage: "It looks like eBay API is down, please try again later.",
                ebayStatusUp: false,
                workflowOriginalValue: null
            }
        },
        mounted() {
            this.reset();
            this.checkSyncInitialStatus();
            if(this.channelType.name == 'eBay'){
                this.checkEbayStatus();
            }
            this.workflowOriginalValue = this.getValueByGroupAndName("Channel Setup", "workflow_id");
        },
        methods : {
            handleShopifyCredentialsModal() {
                console.log('handleShopifyCredentialsModal');

                this.shopifyCredentialsModal = !this.shopifyCredentialsModal;
            },
            toggleToolVisible(key) {
                this.toolState.product = false;
                this.toolState.prices = false;
                this.toolState.inventory = false;
                this.toolState.options = false;
                this.toolState.fullMode = false;
                this.toolState.fullNoAssets = false;
                this.toolState.categories = false;
                this.toolState.locations = false;
                this.toolState[key] = true;
            },
            toolButtonClass(key) {
                if (this.toolState[key]) {
                    return {'btn btn-secondary': true}
                }
                return {'btn btn-primary': true}
            },
            reset() {
                this.dropzoneOptions.url = base_url + '/channels/upload-asset';
                this.currentStates = 0;
                this.uploadedFiles = [];
                this.uploadError = null;
            },
            uploadAssets() {
                this.loading = true;
                if (this.uploadedFiles.length > 1) {
                    this.dropzoneOptions.url = base_url + '/channels/upload-asset';
                }
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/asset', {
                })
                    .then(function(response) {
                        this.loading = false;
                        this.$refs.assetDropzone.removeAllFiles();
                        $('#asset_upload').collapse('toggle');
                        this.uploadPrivate = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Asset uploaded";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = "Error uploading asset";
                        console.log(err);
                    }.bind(this))
            },
            openCreateAsset() {
                $('#asset_upload').collapse('toggle');
            },
            openCreateAssetUrl() {
                $('#create_asset').collapse('toggle');
            },
            createAssetByUrl(){
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/asset', {
                    'assetData' : {
                        'asset_url' : this.assetUploadUrl,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.assetUploadUrl = '';
                        $('#create_asset').collapse('toggle');
                        this.alert.status = "alert-success";
                        this.alert.message = "Asset uploaded";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = "Error uploading asset";
                        console.log(err);
                    }.bind(this));
            },
            deleteChannel(){
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/delete', {
                    'confirm_channel_deletion' : this.confirmChannelDeletion,
                })
                .then(function(res) {
                    this.loading = false;
                    this.confirmChannelDeletion = '';
                    $('#delete_channel').collapse('toggle');
                    this.alert.status = "alert-success";
                    this.alert.message = "Channel Deleted";
                    setTimeout(function() {
                        window.location = "/channels";
                    }, 2000);
                }.bind(this))
                .catch(function(err) {
                    this.loading = false;
                    this.alert.status = "alert-danger";
                    this.alert.message = "Error deleting channel";
                    console.log(err);
                }.bind(this));
            },
            bulkSyncByType(type){
                this.loading = true;

                let confirmationModel, msg, toggleId = '';
                switch(type) {
                    case 'products':
                        confirmationModel = 'confirmSyncProducts';
                        msg = 'Products Sync';
                        toggleId = '#sync_products';
                        break;
                    case 'prices':
                        confirmationModel = 'confirmSyncPrices';
                        msg = 'Prices Sync';
                        toggleId = '#sync_prices';
                        break;
                    case 'inventory':
                        confirmationModel = 'confirmSyncInventory';
                        msg = 'Inventory Sync';
                        toggleId = '#sync_inventory';
                        break;
                    case 'product_options':
                        confirmationModel = 'confirmSyncProductOption';
                        msg = 'Product Options Sync';
                        toggleId = '#sync_product_options';
                        break;
                    case 'products_full':
                        confirmationModel = 'confirmSyncProductsFull';
                        msg = 'Full Products Sync';
                        toggleId = '#sync_products_full';
                        break;
                    case 'products_full_no_assets':
                        confirmationModel = 'confirmSyncProductsFullNoAssets';
                        msg = 'Full Products Sync Except Assets';
                        toggleId = '#sync_products_full_no_assets';
                        break;
                    case 'categories':
                        confirmationModel = 'confirmSyncCategories';
                        msg = 'Categories Sync';
                        toggleId = '#sync_categories';
                        break;
                    case 'locations':
                        confirmationModel = 'confirmSyncLocations';
                        msg = 'Locations Sync';
                        toggleId = '#sync_locations';
                        break;
                }

                axios.post(base_url + '/channels/' + this.channelInfo.id + '/bulk-sync-by-type', {
                    'confirmation' : this[confirmationModel]
                })
                .then(function(res) {
                    this[confirmationModel] = '';
                    $(toggleId).collapse('toggle');
                    this.alert.status = "alert-success";
                    this.alert.message = "Channel " + msg + " Job Dispatched";
                    setTimeout(function() {
                        window.location = "/jobs";
                    }, 2000);
                }.bind(this))
                .catch(function(err) {
                    var sResponse = err.response.data.substring(7);
                    switch (sResponse) {
                        case 'channel is not enabled':
                        case 'failed to dispatch job':
                        case 'invalid channel received':
                            msg += ': '+sResponse;
                            break;
                        default:
                            // do nothing
                    }
                    this.alert.status = "alert-danger";
                    this.alert.message = "Error Dispatching Channel " + msg;
                }.bind(this))
                .finally(function() {
                    this.loading = false;
                }.bind(this));
            },
            runImport() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));

            },
            runImportBigCommerceMSFChannels(importType) {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-bc-import-msfchannels', {'importType': importType})
                .then(function(res) {
                    this.loading = false;
                    this.alert.status = "alert-success";
                    this.alert.message = "Import is running in background";
                }.bind(this))
                .catch(function(err) {
                    this.loading = false;
                    this.alert.status = "alert-danger";
                    this.alert.message = err.response.data.message;
                }.bind(this));
            },
            runImportProductUrl() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-product-url', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportConfig() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-config', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportShopifyChannels() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-shopify-channels', {
                    'data' : {
                        'channelInfo' : this.wyn,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportWynshopStores() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-wynshop-stores', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background - check the status <a href='/jobs'>here</a>";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportWynshopFulfillments() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-wynshop-fulfillments', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background - check the status <a href='/jobs'>here</a>";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportWynshopCategories() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-wynshop-categories', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background - check the status <a href='/jobs'>here</a>";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportShopifyPriceListCountries() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-shopify-countries', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportShopifyInventoryLocations() {
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-shopify-inventory-locations', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Import is running in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));
            },
            runImportShopifyLocalizations(){
                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/run-import-shopify-localizations', {
                    'data' : {
                        'channelInfo' : this.channelInfo,
                    }
                })
                .then(function(res) {
                    this.loading = false;
                    this.alert.status = "alert-success";
                    this.alert.message = "Import is running in background";
                }.bind(this))
                .catch(function(err) {
                    this.loading = false;
                    this.alert.status = "alert-danger";
                    this.alert.message = err.response.data.message;
                }.bind(this));
            },
            uploadAmazonSpreadsheet() {
                var formData = new FormData();
                formData.append('spreadsheet', $('#upload_spreadsheet_file')[0].files[0]);

                console.log(formData);

                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/upload-amazon_spreadsheet',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Amazon spreadsheet will be imported in background";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));

            },
            uploadGoogleJson() {
                var formData = new FormData();
                formData.append('json', $('#upload_google_json_file')[0].files[0]);

                console.log(formData);

                this.loading = true;
                axios.post(base_url + '/channels/' + this.channelInfo.id + '/upload_google_json',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(function(res) {
                        this.loading = false;
                        this.alert.status = "alert-success";
                        this.alert.message = "Google Json file has been uploaded";
                    }.bind(this))
                    .catch(function(err) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = err.response.data.message;
                    }.bind(this));

            },
            setCurrentTab: function(tab_name) {
                this.currentTab = tab_name;
                if (tab_name == 'stats') {
                    this.getChannelStats();
                }
            },
            saveChannel: function (specific) {
                var saveUrl = base_url + "/channels/" + dataObject.channel.id;
                this.loading = true;
                var postData = {
                    currentTab: this.currentTab,
                    items: []
                };

                if (this.currentTab == 'options') {
                    if (this.$refs.channelSpecific) {
                            var channelSpecificData = this.$refs.channelSpecific.channel.items;
                        if (channelSpecificData) {
                            postData.items.push(...channelSpecificData);
                        }
                    }
                } else if (this.currentTab == 'admin') {
                    if (this.$refs.adminSpecific) {
                        var adminSpecificData = this.$refs.adminSpecific.channel.items;
                        if (adminSpecificData) {
                            postData.items.push(...adminSpecificData);
                        }
                    }
                } else if(this.currentTab == 'ftp') {
                    if (this.$refs.ftpSpecific) {
                        var ftpSpecificData = this.$refs.ftpSpecific.channel.items;
                        if (ftpSpecificData) {
                            postData.items.push(...ftpSpecificData);
                        }
                    }
                    saveUrl = base_url + "/ftp_credentials"
                } else {
                    postData = cloneDeep(this.channel);
                    postData.currentTab = this.currentTab;
                }

                axios.post(saveUrl, {
                    'data': postData
                })
                .then(function (response) {
                    this.loading = false;
                    this.alert.status = "alert-success";
                    if (this.currentTab == 'options' && this.channelType.name == 'Pagination.com') {
                        this.alert.message = "Report will be created!";
                    } else {
                        this.alert.message = "Channel successfully saved";
                    }
                    if (this.currentTab == 'details') {
                        this.checkSyncInitialStatus();
                    }
                }.bind(this))
                .catch(function (error) {
                    this.loading = false;
                    this.alert.status = "alert-danger";
                    this.alert.message = error.response ? error.response.data.message : 'An Error Occurred';
                    if ((typeof error.response.data.redirect_url !== 'undefined')) {
                        setTimeout(function () {
                            window.location.href = error.response.data.redirect_url;
                        }, 8000);
                    }
                    }.bind(this));
            },
            getChannelStats: function() {
                this.loading = true;
                axios.get(base_url + "/channels/" + dataObject.channel.id + "/stats")
                    .then(function (response) {
                        this.stats = response.data;
                    }.bind(this))
                    .catch(function (error) {
                        this.alert.status = "alert-danger";
                        this.alert.message = 'Sorry there was an error, please try again later.';
                    }.bind(this))
                    .finally(function () {
                        this.loading = false;
                    }.bind(this));
            },
            showAssets: function() {
                if (this.channelType.name == 'Netsuite') {
                    return false;
                }
                return true;
            },
            showTools: function() {
                if (this.channelType.name == 'Netsuite') {
                    return false;
                }
                return true;
            },
            showStats: function() {
                if (this.channelType.name == 'Netsuite') {
                    return false;
                }
                return true;
            },
            showProductTypes: function() {
                if (this.channelInfo.has_schemas) {
                    return true;
                }
                return false;
            },
            showImport: function() {
                if (this.channelType.inbound) {
                    return true;
                }
                return false;
            },
            filterHiddenFields: function(items) {
                if (Array.isArray(items)) {
                    return items.filter(function (item) {
                        return !item.hide;
                    });
                }

                return items;
            },
            checkSyncInitialStatus: function() {
                this.mountedWithSyncEnabled = this.getCurrentSyncValue();
            },
            checkEbayStatus(){
                axios.get(base_url + "/channels/" + dataObject.channel.id+"/ebaystatus")
                    .then(function (response) {
                        if(response){
                            if(response.status == 200) {
                                this.ebayStatusUp = true;
                                this.ebayResponse = this.ebayStatusSuccessMessage;
                            }
                        } else{
                            this.ebayResponse = this.ebayStatusErrorMessage;
                        }
                    }.bind(this))
                    .catch(function (error) {
                        this.alert.status = "alert-danger";
                        this.alert.message = this.ebayStatusErrorMessage;
                    }.bind(this))
                    .finally(function () {
                        this.loading = false;
                    }.bind(this));
            },
            getCurrentSyncValue: function() {
                let value = '';
                this.channel.items.some((item) => {
                    if (item.groupingName == 'Channel Status') {
                        item.groupItems.some((i) => {
                            if (i.name == 'sync') {
                                value = i.value;

                                return true;
                            }

                            return false;
                        });

                        return true;
                    }

                    return false;
                });
                return value;
            },
            getValueByGroupAndName: function(groupName, propertyName) {
                let channelSetup = this.channel.items.find(i => i['groupingName'] == groupName);
                if(channelSetup)
                {
                    return channelSetup['groupItems'].find(i => i['name'] === propertyName)['value'];
                }
                return null;
            },
            beforeSaveChannel: function() {
                if (this.currentTab == 'details' && this.channelType.sync_type == 'generic_sync_v2' && this.mountedWithSyncEnabled == 'true' && this.getCurrentSyncValue() == 'false') {
                    this.clearSyncModal = true;

                    return;
                }

                if(this.currentTab == 'details' && this.features.includes('channel_workflow'))
                {
                    let that = this;

                    let workflowValue = this.getValueByGroupAndName("Channel Setup", "workflow_id");

                    // first workflow assignment
                    if(!this.workflowOriginalValue && workflowValue)
                    {
                        $.confirm({
                            title: 'Workflow',
                            content: "Do you want to Sync all the existing products in the channel using workflow or Sync them manually?",
                            onOpenBefore: function () {
                                $(".jconfirm-buttons").addClass("btn-block");
                            },
                            buttons: {
                                confirm: {
                                    text: 'Update all products',
                                    btnClass: 'btn btn-block m-0 mb-1 btn-primary border-radius',
                                    action: function () {
                                        that.channel.workflow_bulkUpdate = true;
                                        that.workflowOriginalValue = workflowValue;
                                        that.saveChannel();
                                    }
                                },
                                cancel: {
                                    text: 'I will do it manually',
                                    btnClass: 'btn btn-block m-0 btn-outline-primary border-radius',
                                    action: function () {
                                        that.channel.workflow_bulkUpdate = false;
                                        that.workflowOriginalValue = workflowValue;
                                        that.saveChannel();
                                    }
                                }
                            }
                        });
                        return;
                    }
                    // Remove workflow
                    if(this.workflowOriginalValue && !workflowValue)
                    {
                        $.confirm({
                            title: 'Workflow',
                            content: "Are you sure you whant to disable workflow for all the products on this channel?",
                            buttons: {
                                confirm: {
                                    text: 'Yes',
                                    btnClass: 'btn btn-block btn-info border-radius',
                                    action: function () {
                                        that.saveChannel();
                                        that.workflowOriginalValue = workflowValue;
                                    }
                                },
                                cancel: {
                                    text: 'Cancel',
                                    btnClass: 'btn btn-block btn-outline-primary border-radius',
                                    action: function () {
                                    }
                                }
                            }
                        });
                        return;
                    }
                    else // Change from one workflow to another. Force bulk update
                    {
                        that.channel.workflow_bulkUpdate = true;
                    }
                }

                this.saveChannel();
            },
            closeClearModal: function() {
                this.clearSyncModal = false;
            },
            keepSyncQueue: function() {
                this.closeClearModal();
                this.saveChannel();
            },
            clearSyncQueue: function() {
                this.closeClearModal();

                this.loading = true;
                axios.delete(base_url + "/channels/" + dataObject.channel.id + "/clear_sync_queue")
                    .then(function (response) {
                        this.loading = false;
                        this.$root.$emit('refresh-sync-table');
                        this.saveChannel();
                    }.bind(this))
                    .catch(function (error) {
                        this.loading = false;
                        this.alert.status = "alert-danger";
                        this.alert.message = 'Sorry there was an error, please try again later.';
                    }.bind(this));
            }
        },
        computed: {
            hasSpecificFields: function() {
                if (this.channelType.name == 'BigCommerce' || this.channelType.name == 'Shopify' || this.channelType.name == 'ShopifyGQL' || this.channelType.name == 'Magento2'
                        || this.channelType.name == 'GoogleMerchant' || this.channelType.name == 'Nuorder' || this.channelType.name == 'Wynshop' || this.channelType.name == 'Pagination.com') {
                    return true;
                }
                return false;
            },
            isShopifyChannel: function() {
                return this.channelType.name === 'Shopify' || this.channelType.name === 'ShopifyGQL'
            },
            shopifyChannelItems: function() {
                if (this.isShopifyChannel) {
                    let validCredentials = false;

                    const credentials = this.channel.items.filter((item) => item.groupingName === 'Credentials')[0];

                    if (credentials) {
                        credentials.groupItems.forEach((item) => {
                            if (item.name === 'shopify_api_key' && item.maskedValue.length) {
                                console.log(item, item.maskedValue, item.name);
                                validCredentials = true;
                            }
                        });
                    }

                    return validCredentials ? this.channel.items :
                        this.channel.items.filter((item) => item.groupingName === 'Credentials' || item.groupingName === 'Channel Setup')
                }
            },
            features() {
                return this.$parent.enabledFeatures ? this.$parent.enabledFeatures : [];
            },
        }
    };
</script>
<style scoped lang="scss">
    .jconfirm-box {
        padding: 1rem 2rem !important;
        border-radius: 5px !important;
    }
    .jconfirm-buttons {
        padding: 0;

        button {
            border: 1px solid;
        }
    }

    #channel_details h3 {
        margin-bottom: 0;
    }

    #channel_details ::v-deep .select2-selection__rendered,
    #channel_specific ::v-deep .select2-selection__rendered {
        white-space: normal !important;
        word-break: break-all !important;
        text-overflow: clip !important;
        height: 100% !important;
    }

    .product-details.form-group,
    .product-details::v-deep .form-group {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
    @keyframes opacity {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
    .product-form-tab{
        min-height: 500px;
    }
    figure {
        margin: 0;
        img {
            width: 100px;
            height: 100px;
        }
        i {
            font-size: 100px;
            height: 100px;
        }
    }
    .thumbnail-container{
        position: relative;
        width: 100px;
        height: 100px;
        background-size: cover;
        background-position: center;
        &.has-thumb{
            &:before{
                content: "Thumbnail";
                position: absolute;
                left: calc(50% - 28px);;
                bottom: 5px;
                background-color: rgba(0, 178, 217, 0.82);
                border-radius: 3px;
                padding: 1px 5px;
                color: #fff;
                font-size: 10px;
            }
        }
    }
    .product-asset {
        .btn-group {
            display: flex;
            .btn {
                color: #BABABA;
                border-color: darken(#BABABA, 10%);
                flex: 1;
            }
        }
    }
    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .input-file {
        opacity: 0; /* invisible but it's there! */
        width: 100%;
        height: 200px;
        position: absolute;
        cursor: pointer;
    }
    #assetDropzone > .dz-image {
        z-index: 1 !important;
    }
    .dropzone .dz-preview .dz-image {
        border-radius: 0;
        width: 100%;
        height: 100%;
        z-index: 1 !important;
    }

    .dropzone .dz-preview {
        width: 150px;
    }

    .vue-dropzone>.dz-preview .dz-remove {
        margin-right: 15px !important;
        margin-left: 15px !important;
    }

    .dropzone.dz-started {
        text-align: left;
    }

    .vue-details-loader{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: white;
        z-index: 12;
        text-align: right;
        padding: 5px 10px;
    }

    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label{
        position: relative;
    }
    .sync-buttons {
        flex-wrap: wrap;
        gap: 0.25rem;
    }
    .greenDot {
        height: 10px;
        width: 10px;
        background-color: #00FF00;
        border-radius: 50%;
        display: inline-block;
    }
    .redDot {
        height: 10px;
        width: 10px;
        background-color: #FF0000;
        border-radius: 50%;
        display: inline-block;
    }
</style>
